"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.Text = exports.Header = exports.MobileBox = exports.Box = exports.SiteDown = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SiteDown = (0, _styledComponents["default"])(_slice.Flex)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
exports.SiteDown = SiteDown;
var Box = (0, _styledComponents["default"])(_slice.Box)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  display: none;\n\n  ", " {\n    display: block;\n  }\n"], ["\n  display: none;\n\n  ", " {\n    display: block;\n  }\n"])), _slice.mediaQueries[0]);
exports.Box = Box;
var MobileBox = (0, _styledComponents["default"])(_slice.Box)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  display: block;\n\n  ", " {\n    display: none;\n  }\n"], ["\n  display: block;\n\n  ", " {\n    display: none;\n  }\n"])), _slice.mediaQueries[0]);
exports.MobileBox = MobileBox;
var Header = (0, _styledComponents["default"])(_slice.Flex).attrs({
  as: 'header',
  px: [5, 8],
  py: [5],
  width: 1,
  margin: '0 auto',
  alignItems: 'center',
  flexDirection: 'row'
})(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  height: 84px;\n  max-width: 1500px;\n\n  ", " {\n    height: 110px;\n  }\n"], ["\n  height: 84px;\n  max-width: 1500px;\n\n  ", " {\n    height: 110px;\n  }\n"])), _slice.mediaQueries[0]);
exports.Header = Header;
var Text = (0, _styledComponents["default"])(_slice.Text).attrs({
  fontSize: [4, 6]
})(templateObject_5 || (templateObject_5 = (0, _tslib.__makeTemplateObject)([""], [""])));
exports.Text = Text;
var Button = (0, _styledComponents["default"])(_slice.Button)(templateObject_6 || (templateObject_6 = (0, _tslib.__makeTemplateObject)(["\n  &:hover {\n    color: black;\n  }\n"], ["\n  &:hover {\n    color: black;\n  }\n"])));
exports.Button = Button;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;